import { Component, Input } from '@angular/core';
import type { ParaMilestoneWithStatus } from '../../progress-table/para-milestone.util';
import { domainBadgeColorsFromAccentHex } from '../../utils/para-color.util';
import { clampParaMilestoneIconTier } from '../para-milestone-icon/para-milestone-icon.util';

@Component({
	selector: 'app-para-milestone-status-strip',
	templateUrl: './para-milestone-status-strip.component.html',
})
export class ParaMilestoneStatusStripComponent {
	@Input() milestones: ParaMilestoneWithStatus[] | null | undefined = [];
	@Input() title = 'Milestone';
	@Input() fallbackColor = '#94A3B8';

	get items(): ParaMilestoneWithStatus[] {
		return Array.isArray(this.milestones) ? this.milestones : [];
	}

	iconTier(ms: ParaMilestoneWithStatus, displayIndex0: number): number {
		return clampParaMilestoneIconTier(ms.milestone.sortOrder, displayIndex0 + 1);
	}

	chipColors(ms: ParaMilestoneWithStatus): { border: string; bg: string; label: string; star: string } {
		const accent = ms.milestone.color || this.fallbackColor;
		const badge = domainBadgeColorsFromAccentHex(accent);

		if (ms.status !== 'achieved') {
			return {
				border: 'transparent',
				bg: 'transparent',
				label: '#94A3B8', // slate-400
				star: '#94A3B8', // slate-400
			};
		}

		return {
			border: 'transparent',
			bg: badge.bg,
			label: '#0F172A', // slate-900
			star: accent,
		};
	}
}
